var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendIcon = function SvgSendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 5.751 1.871 1.064a1.345 1.345 0 0 0-1.403.227c-.39.337-.553.857-.425 1.356L1.048 6.59h4.923a.41.41 0 0 1 0 .82H1.048L.043 11.353c-.128.5.035 1.019.425 1.356.39.338.928.424 1.403.227l11.295-4.687C13.68 8.035 14 7.557 14 7c0-.557-.32-1.035-.834-1.249Z",
    fill: "#fff"
  })));
};
export default SvgSendIcon;